import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from './utils/ScrollTop'

import App from './App';
import "@/I18n"
import("@/assets/css/common_style.css")

ReactDOM.render(
  <BrowserRouter>
      <App />
  </BrowserRouter>
  , document.getElementById('root')
);